import React from "react"
import { MdFileDownload } from "react-icons/md"
import { Link } from "gatsby"
import { Heading, Text } from "gatsby-interface"
import { visuallyHiddenCss } from "../../../../components/shared/styles/a11y"
import isOfficialPackage from "../../../../utils/is-official-package"
import GatsbyIcon from "../../../../components/svg/gatsby-monogram"

const resultWrapperCss = (theme, selected) => ({
  padding: theme.space[5],
  background: selected ? theme.colors.purple[5] : theme.colors.grey[5],
  borderRadius: theme.radii[3],
  color: selected ? theme.colors.purple[50] : theme.colors.grey[60],
  transition: theme.transitions.default,
  textDecoration: `none`,
  fontSize: theme.fontSizes[0],

  "&:hover,&:focus": {
    background: theme.colors.white,
    boxShadow: theme.shadows.dialog,
    position: "relative",
  },
})

const headerCss = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
}

const headerDetailsCss = theme => ({
  fontSize: theme.fontSizes[0],
  color: theme.colors.grey[60],

  span: {
    marginLeft: theme.space[3],
  },
  svg: {
    transform: "translateY(2px)",
  },
})

const contentCss = (theme, selected) => ({
  marginTop: theme.space[5],
  overflowWrap: "anywhere",
  color: selected ? theme.colors.purple[50] : theme.colors.grey[60],
})

const linkCss = theme => ({
  fontSize: theme.fontSizes[3],
  textDecoration: "none",
})

// the result component is fed into the InfiniteHits component
export const Result = ({ hit, pathname, query }) => {
  // Example:
  // pathname = `/plugins/gatsby-link/` || `/plugins/@comsoc/gatsby-mdast-copy-linked-files`
  //  hit.name = `gatsby-link` || `@comsoc/gatsby-mdast-copy-linked-files`
  const selected = new RegExp(`^/plugins/${hit.name}/?$`).test(pathname)
  const isOfficial = isOfficialPackage(hit)

  return (
    <Link
      to={query ? `/plugins/${hit.name}/?=${query}` : `/plugins/${hit.name}`}
      aria-current={selected ? `true` : undefined}
      css={linkCss}
    >
      <div css={theme => resultWrapperCss(theme, selected)}>
        <div css={headerCss}>
          <Heading
            as="h4"
            css={theme => ({
              flex: 1,
              color: selected ? theme.colors.purple[50] : theme.colors.grey[60],
              fontFamily: theme.fonts.body,
              fontSize: theme.fontSizes[1],
            })}
          >
            {hit.name}
          </Heading>

          <div css={headerDetailsCss}>
            {isOfficial && (
              <React.Fragment>
                <span aria-hidden={true}>
                  <GatsbyIcon />
                </span>

                <p css={visuallyHiddenCss}>{`Official Gatsby Plugin`}</p>
              </React.Fragment>
            )}

            <span>
              <MdFileDownload />
              {` `}
              {hit.humanDownloadsLast30Days.includes("m")
                ? hit.humanDownloadsLast30Days.toUpperCase()
                : hit.humanDownloadsLast30Days}
            </span>

            <p css={visuallyHiddenCss}>
              {hit.downloadsLast30Days} monthly downloads
            </p>
          </div>
        </div>

        <Text size="S" css={theme => contentCss(theme, selected)}>
          <div dangerouslySetInnerHTML={{ __html: hit.description }} />
        </Text>
      </div>
    </Link>
  )
}
